import Vue from "vue";

export default {
  recuperarFilas() {
    return Vue.axios.get("fila/all");
  },
};